import React, { useState, useContext } from 'react';
import { SafeAreaView, ScrollView, View } from 'react-native';
import { ApolloProvider } from '@apollo/client';
import styled from 'styled-components/native';
import ClientContext from 'app/src/contexts/ClientContext';

import About from 'app/src/components/About';
import Footer from 'app/src/components/Footer';
import Menu from 'app/src/components/Menu/Public';
import { Loading } from 'app/src/elements/DataState';
import useScreenSize from 'app/src/hooks/useScreenSize';

import LoginToken from './LoginToken';
import RegisterLogin from './new';
import SetPassword from './SetPassword';
import ResetPassword from './ResetPassword';

const Screen = styled(SafeAreaView)`
  min-height: 100vh;
  flex: 1;
`;

const ContentContainer = styled(View)`
  flex: 1;
  jusiify-content: flex-start;
  align-self: center;
  gap: 60px;
  padding: 20px;
  maxWidth: 400px;
`;

const Content = styled(View)`
  width: 400px;
  padding: 20px;
`;

const Auth = () => {
  const {
    apolloClientForAuth, isLoggedIn, storageChecked
  } = useContext(ClientContext);

  const { isScreenSize } = useScreenSize();

  const params = window.location ?
    new URLSearchParams(window.location.search) : null;
  const loginToken = params?.get('loginToken');
  const inviteToken = params?.get('inviteToken');
  const resetToken = params?.get('resetToken') ||
    params?.get('reset_password_token');

  let content = <Loading />;

  if (loginToken) {
    content = <LoginToken token={loginToken} />;
  } else if (inviteToken) {
    content = <SetPassword token={inviteToken} />;
  } else if (resetToken) {
    content = <ResetPassword token={resetToken} />;
  } else if (storageChecked) {
    content = <RegisterLogin />;
  };

  return (
    <ApolloProvider client={apolloClientForAuth}>
      <Screen>
        <Menu />

        <ContentContainer isMobile={isScreenSize('mobile')}>
          <Content>
            {content}
          </Content>

          <About />
        </ContentContainer>

        <Footer />
      </Screen>
    </ApolloProvider>
  );
};

export default Auth;
